import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-marketplace-pop-up',
  templateUrl: './marketplace-pop-up.component.html',
  styleUrls: ['./marketplace-pop-up.component.scss']
})
export class MarketplacePopUpComponent {
  constructor(
    public dialogRef: MatDialogRef<MarketplacePopUpComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private translate: TranslateService
  ) {}

  closeDialog(): void {
    this.dialogRef.close();
  }
} 